import { EnvironmentProviders, Provider } from '@angular/core';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics, ScreenTrackingService } from '@angular/fire/analytics';

import { firebaseClientConfig, hasFirebaseClientConfig } from './firebase.config';

export const firebaseAnalyticsEnabled = hasFirebaseClientConfig(firebaseClientConfig);

export const firebaseProviders: Array<EnvironmentProviders | Provider> = firebaseAnalyticsEnabled
  ? [
      provideFirebaseApp(() => initializeApp(firebaseClientConfig)),
      provideAnalytics(() => getAnalytics()),
      ScreenTrackingService
    ]
  : [];
